module.exports = __webpack_public_path__ + "static/media/m_y_18.bcc0a733.png";